var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{staticClass:"ml-4",attrs:{"items":_vm.years(),"item-text":"value","item-value":"key","menu-props":"auto","hide-details":"","label":_vm.yearSelected.value,"single-line":""},model:{value:(_vm.yearSelected),callback:function ($$v) {_vm.yearSelected=$$v},expression:"yearSelected"}})
}
var staticRenderFns = []

export { render, staticRenderFns }